/* Pawubs — asset: pawubs-page.js
   Versión conectada a productos reales renderizados por Shopify Liquid.
*/

(function () {
  var ROOT = document.querySelector('.pawubs-page');

  if (!ROOT) return;

  ROOT.classList.add('js-on');

/* Logo: recargar la página principal y volver arriba */
var homeLogo = ROOT.querySelector('[data-logo-home]');

function forcePageTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/* Detectar que se llegó mediante el logo */
var currentUrl = new URL(window.location.href);
var shouldGoTop = currentUrl.searchParams.get('go_top') === '1';

if (shouldGoTop) {
  history.scrollRestoration = 'manual';

  forcePageTop();

  requestAnimationFrame(function () {
    forcePageTop();
  });

  window.addEventListener('load', function () {
    forcePageTop();

    setTimeout(function () {
      forcePageTop();
    }, 100);

    setTimeout(function () {
      forcePageTop();

      /* Quitar el parámetro sin recargar otra vez */
      currentUrl.searchParams.delete('go_top');

      history.replaceState(
        null,
        '',
        currentUrl.pathname +
          currentUrl.search +
          currentUrl.hash
      );
    }, 400);
  });
}

if (homeLogo) {
  homeLogo.addEventListener('click', function (event) {
    event.preventDefault();

    forcePageTop();

    window.location.href = homeLogo.getAttribute('href');
  });
}
  /* La recarga siempre empieza arriba */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function toTop() {
    window.scrollTo(0, 0);
  }

  if (location.hash) {
    history.replaceState(
      null,
      '',
      location.pathname + location.search
    );

    toTop();

    window.addEventListener('load', toTop, {
      once: true
    });
  }

  /*
   * Enlaces internos:
   * desplazan la página sin dejar el hash en la URL.
   */
  ROOT.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');

    if (!link) return;

    var id = link.getAttribute('href').slice(1);

    event.preventDefault();

    if (!id) {
      toTop();
      return;
    }

    var destination = ROOT.querySelector('#' + id);

    if (destination) {
      destination.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      toTop();
    }
  });

  var grid = ROOT.querySelector('#grid');
  var arrowLeft = ROOT.querySelector('#arwL');
  var arrowRight = ROOT.querySelector('#arwR');
  var railBar = ROOT.querySelector('#railBar');
  var filters = ROOT.querySelector('#filters');
  var toast = ROOT.querySelector('#toast');
  var cartCounter = ROOT.querySelector('#cartN');

  function getCards() {
    if (!grid) return [];

    return Array.from(
      grid.querySelectorAll('.pw-product-card')
    );
  }

  function getVisibleCards() {
    return getCards().filter(function (card) {
      return !card.hidden;
    });
  }

  function updateNavigation() {
    if (!grid) return;

    var maximumScroll =
      grid.scrollWidth - grid.clientWidth;

    var hasOverflow = maximumScroll > 8;

    if (arrowLeft) {
      arrowLeft.hidden =
        !hasOverflow ||
        grid.scrollLeft < 12;
    }

    if (arrowRight) {
      arrowRight.hidden =
        !hasOverflow ||
        grid.scrollLeft > maximumScroll - 12;
    }

    grid.classList.toggle(
      'pw-at-end',
      !hasOverflow ||
      grid.scrollLeft > maximumScroll - 12
    );

    if (railBar && railBar.parentNode) {
      railBar.parentNode.style.display =
        hasOverflow ? '' : 'none';

      var visiblePercentage = Math.max(
        12,
        grid.clientWidth / grid.scrollWidth * 100
      );

      railBar.style.width =
        visiblePercentage + '%';

      var progress =
        maximumScroll > 0
          ? grid.scrollLeft / maximumScroll
          : 0;

      var translation =
        progress *
        (
          100 / visiblePercentage * 100 - 100
        );

      railBar.style.transform =
        'translateX(' + translation + '%)';
    }
  }

  function moveCarousel(direction) {
    if (!grid) return;

    var card = getVisibleCards()[0];

    var cardWidth = card
      ? card.getBoundingClientRect().width + 22
      : 360;

    var visibleCards = Math.max(
      1,
      Math.floor(
        grid.clientWidth / cardWidth
      )
    );

    grid.scrollBy({
      left:
        direction *
        cardWidth *
        visibleCards,
      behavior: 'smooth'
    });
  }

  if (arrowLeft) {
    arrowLeft.addEventListener(
      'click',
      function () {
        moveCarousel(-1);
      }
    );
  }

  if (arrowRight) {
    arrowRight.addEventListener(
      'click',
      function () {
        moveCarousel(1);
      }
    );
  }

  if (grid) {
    grid.addEventListener(
      'scroll',
      updateNavigation,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      updateNavigation
    );

    grid.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          moveCarousel(1);
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          moveCarousel(-1);
        }
      }
    );

    /*
     * Permite arrastrar el carrusel
     * usando el mouse.
     */
    var dragging = false;
    var initialX = 0;
    var initialScroll = 0;
    var movedDistance = 0;

    grid.addEventListener(
      'pointerdown',
      function (event) {
        if (event.pointerType !== 'mouse') {
          return;
        }

        dragging = true;
        initialX = event.clientX;
        initialScroll = grid.scrollLeft;
        movedDistance = 0;

        grid.style.scrollSnapType = 'none';
        grid.style.cursor = 'grabbing';
      }
    );

    grid.addEventListener(
      'pointermove',
      function (event) {
        if (!dragging) return;

        var distance =
          event.clientX - initialX;

        movedDistance =
          Math.abs(distance);

        if (movedDistance > 4) {
          grid.scrollLeft =
            initialScroll - distance;
        }
      }
    );

    [
      'pointerup',
      'pointerleave',
      'pointercancel'
    ].forEach(function (eventName) {
      grid.addEventListener(
        eventName,
        function () {
          if (!dragging) return;

          dragging = false;

          grid.style.scrollSnapType = '';
          grid.style.cursor = '';
        }
      );
    });

    grid.addEventListener(
      'click',
      function (event) {
        if (movedDistance > 6) {
          event.preventDefault();
        }
      },
      true
    );
  }

  function cardMatchesFilter(card, filter) {
    if (filter === 'all') {
      return true;
    }

    var categories = (
      card.getAttribute('data-category') || ''
    ).toLowerCase();

    var list = categories
      .split(/\s+/)
      .filter(Boolean);

    return list.indexOf(
      filter.toLowerCase()
    ) !== -1;
  }

function applyFilter(filter) {
  if (!grid) return;

  getCards().forEach(function (card) {
    var shouldShow = cardMatchesFilter(card, filter);

    card.hidden = !shouldShow;
    card.style.display = shouldShow ? 'flex' : 'none';
    card.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );
  });

  grid.scrollLeft = 0;

  requestAnimationFrame(function () {
    updateNavigation();
  });
}

  /*
   * Agrega el contador a cada filtro
   * usando los productos reales.
   */
  ROOT.querySelectorAll(
    '.pw-chip'
  ).forEach(function (chip) {
    var filter =
      chip.dataset.f || 'all';

    var count = getCards().filter(
      function (card) {
        return cardMatchesFilter(
          card,
          filter
        );
      }
    ).length;

    var label = chip.childNodes.length
      ? chip.childNodes[0]
          .textContent
          .trim()
      : chip.textContent.trim();

    chip.innerHTML =
      label + '<b>' + count + '</b>';
  });

  if (filters) {
    filters.addEventListener(
      'click',
      function (event) {
        var button =
          event.target.closest('.pw-chip');

        if (!button) return;

        ROOT.querySelectorAll(
          '.pw-chip'
        ).forEach(function (chip) {
          chip.classList.remove('pw-on');
        });

        button.classList.add('pw-on');

        applyFilter(
          button.dataset.f || 'all'
        );
      }
    );
  }

  /*
   * Los enlaces Dogs, Cats, Grooming,
   * Feeding, etc. activan su filtro.
   */
  ROOT.querySelectorAll(
    '[data-jump]'
  ).forEach(function (link) {
    link.addEventListener(
      'click',
      function () {
        var filter =
          link.dataset.jump;

        var chip =
          ROOT.querySelector(
            '.pw-chip[data-f="' +
            filter +
            '"]'
          );

        if (chip) {
          chip.click();
        }
      }
    );
  });

  function showToast(message) {
    if (!toast) return;

    toast.textContent = message;

    toast.classList.add('pw-show');

    window.setTimeout(
      function () {
        toast.classList.remove(
          'pw-show'
        );
      },
      2400
    );
  }

  function updateCartCount() {
    fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'No se pudo leer el carrito.'
          );
        }

        return response.json();
      })
      .then(function (cart) {
        if (cartCounter) {
          cartCounter.textContent =
            cart.item_count;
        }
      })
      .catch(function () {
        /*
         * El formulario seguirá funcionando
         * aunque falle el contador.
         */
      });
  }

  /*
   * Agrega productos reales al carrito
   * sin recargar la página.
   */
  if (grid) {
    grid.addEventListener(
      'submit',
      function (event) {
        var form =
          event.target.closest(
            '.pw-product-form'
          );

        if (!form) return;

        event.preventDefault();

        var button =
          form.querySelector(
            '.pw-product-add'
          );

        var card =
          form.closest(
            '.pw-product-card'
          );

        var titleElement = card
          ? card.querySelector(
              '.pw-product-title'
            )
          : null;

        var title = titleElement
          ? titleElement
              .textContent
              .trim()
          : 'Producto';

        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }

        var formData =
          new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) {
              return response
                .json()
                .then(function (data) {
                  throw new Error(
                    data.description ||
                    'No se pudo agregar el producto.'
                  );
                });
            }

            return response.json();
          })
          .then(function () {
            if (button) {
              button.textContent =
                'Added ✓';

              button.classList.add(
                'pw-done'
              );
            }

            showToast(
              title + ' added to cart'
            );

            updateCartCount();

            window.setTimeout(
              function () {
                if (!button) return;

                button.disabled = false;
                button.textContent = 'Add';

                button.classList.remove(
                  'pw-done'
                );
              },
              1600
            );
          })
          .catch(function (error) {
            if (button) {
              button.disabled = false;
              button.textContent = 'Add';
            }

            showToast(
              error.message ||
              'No se pudo agregar el producto.'
            );
          });
      }
    );
  }

  /* Animaciones al aparecer */

  if (
    'IntersectionObserver' in window
  ) {
    var observer =
      new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              if (
                !entry.isIntersecting
              ) {
                return;
              }

              entry.target.classList.add(
                'pw-in'
              );

              observer.unobserve(
                entry.target
              );
            }
          );
        },
        {
          threshold: 0.14
        }
      );

    ROOT.querySelectorAll(
      '.pw-rv'
    ).forEach(function (element) {
      observer.observe(element);
    });
  } else {
    ROOT.querySelectorAll(
      '.pw-rv'
    ).forEach(function (element) {
      element.classList.add('pw-in');
    });
  }

  /* Carrusel de reseñas */

  var track =
    ROOT.querySelector('#track');

  if (
    track &&
    !track.dataset.duplicated
  ) {
    track.innerHTML +=
      track.innerHTML;

    track.dataset.duplicated =
      'true';
  }

  /* Navegación fija */

  var nav =
    ROOT.querySelector('#nav');

  if (nav) {
    window.addEventListener(
      'scroll',
      function () {
        nav.classList.toggle(
          'pw-stuck',
          window.scrollY > 20
        );
      },
      {
        passive: true
      }
    );
  }

  /* Estado inicial */

  applyFilter('all');
  updateCartCount();

  window.setTimeout(
    updateNavigation,
    60
  );
})();